import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import { Box, IconButton, Tooltip } from '@mui/material';
import type { IframeController } from '@ocodelib/iframe-parent';
import { useState } from 'react';
import { IframeWrapperNoSsr } from '../iframes';
import { usePyBasicApp } from '../usePyBasicApp';

export function PyReplCodingContent() {
  const [refreshToken, setRefreshToken] = useState(0);
  const [iframeController, setIframeController] = useState<IframeController | null>(null);
  const { appManager } = usePyBasicApp();
  const datiBaseURL = appManager.appConfig.datiBaseURL;

  const handleLoadIframe = (iframe: IframeController | null) => {
    setIframeController(iframe);
  };

  return (
    <Box
      className="PyReplCodingContent-root"
      sx={{
        flex: 1,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
      }}
    >
      <HeaderBox
        disabled={!iframeController}
        onClickConsoleClear={() => {
          iframeController?.runCmd('clear');
        }}
      />
      <Box
        sx={{
          position: 'relative',
          flex: 1,
          '& > iframe': {
            position: 'absolute',
            top: 0,
            left: 0,
            width: 'calc(100% - 2px)',
            height: 'calc(100% - 2px)',
          },
        }}
      >
        <IframeWrapperNoSsr
          key={refreshToken}
          datiBaseURL={datiBaseURL}
          // devUrl="http://localhost:9011"
          className="DevIframePyRunnerRepl-iframe"
          idPrefix="py-runner-repl"
          urlPath="/sys.iframe/py-runner/repl.html"
          onLoad={handleLoadIframe}
        />
      </Box>
    </Box>
  );
}

function HeaderBox(props: { disabled?: boolean; onClickConsoleClear?: React.MouseEventHandler }) {
  const { disabled, onClickConsoleClear } = props;
  return (
    <Box
      sx={{
        bgcolor: '#edeff1',
        height: 40,
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        px: 2,
      }}
    >
      <Tooltip title="clear log">
        <span>
          <IconButton
            size="small"
            color="primary"
            disabled={disabled}
            onClick={onClickConsoleClear}
            sx={{ ml: 'auto', color: '#888' }}
          >
            <CleaningServicesIcon />
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
}
